import { useDeliveryEstimateQuery } from '../../GraphQL/Checkout.generated';

/**
 * Given a cart address id, return the estimate for its delivery.
 * This is only needed for delivery carts for the ASAP delivery time option.
 */
export const useDeliveryEstimate = (addressId?: string) => {
  const [response] = useDeliveryEstimateQuery({
    variables: { input: { addressId } },
    pause: !addressId,
  });

  const result = response?.data?.locationByAddress;

  if (result?.__typename === 'Location') {
    return {
      deliveryEstimate: result.estimateRange,
      isLoadingDeliveryEstimate: false,
    };
  }

  return {
    deliveryEstimate: null,
    isLoadingDeliveryEstimate: response.fetching,
  };
};
